import { useContext } from 'react'
import { LocationSelectionMapContext } from 'Context/LocationSelectionModal'

const ViewModel = () => {
  const { open, setOpen, position, setPosition, setChangeConfirm } = useContext(
    LocationSelectionMapContext
  )

  const handleClose = () => {
    setOpen(false)
  }

  const handleConfirm = () => {
    setOpen(false)
    setChangeConfirm(true)
  }

  return {
    open,
    handleClose,
    handleConfirm,
    position,
    setPosition,
  }
}

export default ViewModel
